import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donation-setup/infrastructure";

export const Route = createFileRoute("/admin/_donation-setup/infrastructure")({
  component: Page,
});
